import React, { useState, useEffect } from 'react';
import { API_BASE } from './api';

export default function JevPublicView({ token }) {
  const [jevData, setJevData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [approving, setApproving] = useState(false);
  const [approvedSuccess, setApprovedSuccess] = useState(false);
  const [customerNotes, setCustomerNotes] = useState('');

  const statusSteps = [
    { code: 'RECEBIDO', label: 'Recebido na Oficina', icon: '🔑' },
    { code: 'EM_DIAGNOSTICO', label: 'Em Diagnóstico', icon: '🔍' },
    { code: 'AGUARDANDO_APROVACAO', label: 'Aguardando Aprovação', icon: '📋' },
    { code: 'EM_MANUTENCAO', label: 'Em Manutenção', icon: '🛠️' },
    { code: 'PRONTO_PARA_RETIRADA', label: 'Pronto para Retirada', icon: '🚀' },
    { code: 'ENTREGUE', label: 'Entregue', icon: '✅' }
  ];

  useEffect(() => {
    if (token) {
      fetchPublicJev();
    }
  }, [token]);

  const fetchPublicJev = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/jev/public/${token}`);
      if (res.ok) {
        const data = await res.json();
        setJevData(data);
      } else {
        setError('Laudo de Vistoria JEV não encontrado ou link expirado.');
      }
    } catch (err) {
      setError('Erro ao carregar os dados da Vistoria.');
    } finally {
      setLoading(false);
    }
  };

  const handleApproveBudget = async () => {
    setApproving(true);
    try {
      const res = await fetch(`${API_BASE}/api/jev/public/${token}/approve`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_notes: customerNotes
        })
      });

      if (res.ok) {
        setApprovedSuccess(true);
        fetchPublicJev();
      } else {
        alert('Erro ao aprovar orçamento.');
      }
    } catch (err) {
      alert('Falha de conexão.');
    } finally {
      setApproving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ background: '#0f172a', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#f8fafc', fontFamily: 'Inter, sans-serif' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '40px', marginBottom: '12px' }}>🚗</div>
          <div>Carregando Jornada Eletrônica Veicular...</div>
        </div>
      </div>
    );
  }

  if (error || !jevData) {
    return (
      <div style={{ background: '#0f172a', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#f8fafc', padding: '20px', fontFamily: 'Inter, sans-serif' }}>
        <div style={{ background: '#1e293b', padding: '32px', borderRadius: '20px', border: '1px solid #334155', textAlign: 'center', maxWidth: '400px' }}>
          <div style={{ fontSize: '48px', marginBottom: '12px' }}>⚠️</div>
          <h2 style={{ fontSize: '18px', color: '#f87171' }}>Ops! Laudo Não Encontrado</h2>
          <p style={{ color: '#94a3b8', fontSize: '14px' }}>{error}</p>
        </div>
      </div>
    );
  }

  const currentStepIdx = statusSteps.findIndex(s => s.code === jevData.status);

  return (
    <div style={{ background: '#0f172a', minHeight: '100vh', color: '#f8fafc', padding: '24px 16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ maxWidth: '700px', margin: '0 auto' }}>
        
        {/* Cabeçalho da Oficina & Veículo */}
        <div style={{ background: 'linear-gradient(135deg, #1e293b, #0f172a)', border: '1px solid #334155', borderRadius: '24px', padding: '24px', marginBottom: '20px', boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3)' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '12px', marginBottom: '16px' }}>
            <div>
              <span style={{ fontSize: '11px', fontWeight: '700', color: '#38bdf8', letterSpacing: '1px', textTransform: 'uppercase' }}>
                {jevData.tenant_name || 'Oficina Mecânica'}
              </span>
              <h1 style={{ margin: '4px 0 0 0', fontSize: '24px', fontWeight: '800', color: '#f8fafc' }}>
                {jevData.vehicle_model || 'Veículo'} {jevData.vehicle_year ? `(${jevData.vehicle_year})` : ''}
              </h1>
            </div>
            <div style={{ background: '#0284c720', border: '1px solid #0284c7', color: '#38bdf8', padding: '4px 12px', borderRadius: '8px', fontSize: '14px', fontWeight: '800', letterSpacing: '1px' }}>
              {jevData.vehicle_plate || 'PLACA'}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', background: '#0f172a', padding: '12px', borderRadius: '12px', fontSize: '13px', color: '#cbd5e1' }}>
            <div>👤 <strong>Proprietário:</strong> {jevData.customer_name || 'Cliente'}</div>
            <div>🛣️ <strong>KM de Entrada:</strong> {jevData.mileage ? `${jevData.mileage.toLocaleString()} KM` : 'N/I'}</div>
            <div>👨‍🔧 <strong>Técnico:</strong> {jevData.technician_name || 'Equipe Técnica'}</div>
            <div>⛽ <strong>Combustível:</strong> {jevData.fuel_level}%</div>
          </div>
        </div>

        {/* Linha do Tempo da Jornada */}
        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '24px', padding: '24px', marginBottom: '20px' }}>
          <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: '#60a5fa', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>📍</span> Status da Jornada em Tempo Real
          </h3>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {statusSteps.map((step, idx) => {
              const isDone = idx < currentStepIdx;
              const isCurrent = idx === currentStepIdx;

              return (
                <div key={step.code} style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <div style={{
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    background: isCurrent ? '#3b82f6' : isDone ? '#10b98120' : '#0f172a',
                    border: '2px solid',
                    borderColor: isCurrent ? '#60a5fa' : isDone ? '#10b981' : '#334155',
                    color: isCurrent ? '#fff' : isDone ? '#34d399' : '#64748b',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '700'
                  }}>
                    {isDone ? '✓' : step.icon}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '14px', fontWeight: isCurrent ? '700' : '500', color: isCurrent ? '#f8fafc' : isDone ? '#e2e8f0' : '#64748b' }}>
                      {step.label}
                    </div>
                  </div>
                  {isCurrent && (
                    <span style={{ background: '#3b82f620', border: '1px solid #3b82f6', color: '#60a5fa', padding: '2px 8px', borderRadius: '12px', fontSize: '11px', fontWeight: '700' }}>
                      ATUAL
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Card de Aprovação de Orçamento (se aguardando aprovação) */}
        {['RECEBIDO', 'EM_DIAGNOSTICO', 'AGUARDANDO_APROVACAO'].includes(jevData.status) && (
          <div style={{ background: 'linear-gradient(135deg, #1e1b4b, #1e293b)', border: '1px solid #6366f1', borderRadius: '24px', padding: '24px', marginBottom: '20px', boxShadow: '0 10px 25px rgba(99, 102, 241, 0.2)' }}>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', color: '#818cf8', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>✍️</span> Aprovação do Orçamento de Manutenção
            </h3>
            <p style={{ margin: '0 0 16px 0', fontSize: '13px', color: '#cbd5e1' }}>
              Estimativa do Serviço: <strong style={{ color: '#34d399', fontSize: '18px' }}>R$ {jevData.estimated_cost?.toFixed(2) || '0.00'}</strong>
            </p>

            {approvedSuccess ? (
              <div style={{ background: '#10b98120', border: '1px solid #10b981', color: '#34d399', padding: '16px', borderRadius: '12px', textAlign: 'center', fontWeight: '600' }}>
                ✅ Orçamento Aprovado com Sucesso! A oficina já iniciou os serviços no seu veículo.
              </div>
            ) : (
              <div>
                <textarea
                  placeholder="Observações ou instruções para a oficina (opcional)..."
                  value={customerNotes}
                  onChange={e => setCustomerNotes(e.target.value)}
                  style={{ width: '100%', background: '#0f172a', border: '1px solid #334155', color: '#fff', padding: '10px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px', minHeight: '60px' }}
                />
                <button
                  onClick={handleApproveBudget}
                  disabled={approving}
                  style={{
                    width: '100%',
                    background: 'linear-gradient(135deg, #10b981, #059669)',
                    color: '#fff',
                    border: 'none',
                    padding: '14px',
                    borderRadius: '12px',
                    fontSize: '15px',
                    fontWeight: '700',
                    cursor: 'pointer',
                    boxShadow: '0 4px 14px rgba(16, 185, 129, 0.4)'
                  }}
                >
                  {approving ? 'Enviando Aprovação...' : '✅ Aprovar Orçamento e Iniciar Manutenção'}
                </button>
              </div>
            )}
          </div>
        )}

        {/* Checklist de Segurança */}
        <div style={{ background: '#1e293b', border: '1px solid #334155', borderRadius: '24px', padding: '24px', marginBottom: '20px' }}>
          <h3 style={{ margin: '0 0 14px 0', fontSize: '16px', color: '#38bdf8' }}>Checklist Técnico de Segurança</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '10px' }}>
            {Object.entries(jevData.checklist_safety || {}).map(([k, v]) => (
              <div key={k} style={{ background: '#0f172a', padding: '10px 14px', borderRadius: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '13px' }}>
                <span style={{ textTransform: 'capitalize' }}>{k.replace('_', ' ')}</span>
                <span style={{
                  background: v === 'OK' ? '#10b98120' : v === 'ATENCAO' ? '#f59e0b20' : '#ef444420',
                  color: v === 'OK' ? '#34d399' : v === 'ATENCAO' ? '#fbbf24' : '#f87171',
                  padding: '2px 8px',
                  borderRadius: '6px',
                  fontWeight: '700',
                  fontSize: '11px'
                }}>
                  {v}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Contactar Oficina */}
        {jevData.tenant_phone && (
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <a
              href={`https://wa.me/${jevData.tenant_phone.replace(/\D/g, '')}`}
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                background: '#25d366',
                color: '#fff',
                padding: '12px 24px',
                borderRadius: '30px',
                fontWeight: '700',
                textDecoration: 'none',
                fontSize: '14px',
                boxShadow: '0 4px 14px rgba(37, 211, 102, 0.4)'
              }}
            >
              💬 Falar com a Oficina no WhatsApp
            </a>
          </div>
        )}

      </div>
    </div>
  );
}
